import React from 'react';
import { LabelField, ImageField } from '../../components/Admin';

export default class About extends React.Component {
	addImage = _ => {
		var { website, onChangeProp } = this.props;
		var websiteImage = [...website.websiteImage];
		websiteImage.push({imageId: '', websiteId: website.websiteId});
		onChangeProp("websiteImage", websiteImage);
	}

	onChangeImage = (index, value, dataURL) => {
		var { onChangeKey } = this.props;
		onChangeKey(({website, files}) => {
			console.log(files);
			website.websiteImage[index].imageId = dataURL;
			files[`websiteImage.${index}`] = value;
			return { website, files };
		});
	}

	onRemoveImage = (index) => {
		var { onChangeKey } = this.props;
		onChangeKey(({website, files}) => {
			website.websiteImage.splice(index, 1);
			delete files[`websiteImage.${index}`];
			return { website, files };
		});
	};

	render(){
		var { website, onChangeProp } = this.props;
		return (
			<div>
				<LabelField defaultValue={website.aboutTitle} onChange={onChangeProp} prop="aboutTitle" name="Título" info="40 caracteres" />
				<LabelField defaultValue={website.about} onChange={onChangeProp} prop="about" name="Descripción" info="1024 caracteres" rows={8} />
				<div className="label-field image-list">
					<label>Galería <span>Al menos 1280x720</span></label>
					{website.websiteImage.map((webImage, k) => (
						<div className="wp-image" key={`${k}${webImage.imageId.substr(0, 36)}`}>
							<ImageField
								defaultValue={webImage.image}
								onChange={(_, value, uri) => this.onChangeImage(k, value, uri)}
								prop="imageId"
								showLabel={false} />
							<span onClick={_ => this.onRemoveImage(k)} className="icon-remove"></span>
						</div>

					))}
					<div onClick={this.addImage} className="add-item">
						Agregar Imagen
					</div>
				</div>
			</div>
		)
	}
}
